if (!customElements.get("m-promo-mobile-slider")) {
  class MPromoMobileSlider extends HTMLElement {
    connectedCallback() {
      this.section = this.closest(".sf-home__promo-grid");
      if (!this.section) return;

      this.scroller = this.section.querySelector(".m-mixed-layout--mobile-scroll");
      this.wrapper = this.section.querySelector(".m-custom-content__wrapper");
      this.cards = Array.from(this.scroller.querySelectorAll(".m-custom-content__block"));
      if (!this.scroller || !this.wrapper || !this.cards.length) return;

      this.currentIndex = 0;
      this.handleResize = this.handleResize.bind(this);
      this.handleScroll = this.handleScroll.bind(this);

      window.addEventListener("resize", this.handleResize);
      this.scroller.addEventListener("scroll", this.handleScroll, { passive: true });
      this.handleResize();
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
      this.scroller?.removeEventListener("scroll", this.handleScroll);
      this.removeControls();
    }

    handleResize() {
      if (window.innerWidth <= 767) {
        this.cards = Array.from(this.scroller.querySelectorAll(".m-custom-content__block"));
        this.currentIndex = Math.min(this.currentIndex, Math.max(this.cards.length - 1, 0));
        this.ensureControls();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.scrollToCard(this.currentIndex, "auto");
          });
        });
      } else {
        this.removeControls();
      }
    }

    ensureControls() {
      if (this.controls) return;

      const controls = document.createElement("div");
      controls.className = "m-slider-controls m-slider-controls--group m-slider-controls--show-nav sf-promo-mobile-controls";
      controls.innerHTML = `
        <div class="m-slider-controls__wrapper">
          <button class="m-slider-controls__button sf-promo-mobile-prev" aria-label="Previous">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
          <button class="m-slider-controls__button sf-promo-mobile-next" aria-label="Next">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        </div>
      `;

      controls.querySelector(".sf-promo-mobile-prev").addEventListener("click", () => {
        this.currentIndex = (this.currentIndex - 1 + this.cards.length) % this.cards.length;
        this.scrollToCard(this.currentIndex);
      });

      controls.querySelector(".sf-promo-mobile-next").addEventListener("click", () => {
        this.currentIndex = (this.currentIndex + 1) % this.cards.length;
        this.scrollToCard(this.currentIndex);
      });

      this.scroller.insertAdjacentElement("afterend", controls);
      this.controls = controls;
    }

    removeControls() {
      if (this.controls) {
        this.controls.remove();
        this.controls = null;
      }
    }

    scrollToCard(index, behavior = "smooth") {
      const card = this.cards[index];
      if (!card) return;

      const targetLeft = Math.max(card.offsetLeft - this.wrapper.offsetLeft, 0);

      this.scroller.scrollTo({
        left: targetLeft,
        behavior,
      });
    }

    handleScroll() {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        const scrollLeft = this.scroller.scrollLeft;
        let nearestIndex = 0;
        let nearestDistance = Infinity;

        this.cards.forEach((card, index) => {
          const cardLeft = Math.max(card.offsetLeft - this.wrapper.offsetLeft, 0);
          const distance = Math.abs(cardLeft - scrollLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        this.currentIndex = nearestIndex;
      }, 80);
    }
  }

  customElements.define("m-promo-mobile-slider", MPromoMobileSlider);
}
